import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import { Controller, useForm } from 'react-hook-form';
import { ConfirmationModal, TextField } from 'seagull';
import { agreementNameValidation } from '~/business-logic/validators';
import { useStoreActions } from '~/contexts';
import { useUpdateRelationship } from '~/hooks/useUpdateRelationship';
import { useLocaleKeys } from '~/i18n';
import { agreementChangeModel } from '~/models';
import { connectControllerToTextField } from '~/utils/react-hook-form.utils';
import styles from './RenameAgreementModal.module.scss';
export default function RenameAgreementModal(props) {
    const { relationship, onSuccess, dismissModal } = props;
    const { t: texts } = useLocaleKeys('pages.agreementsDashboard.renameModal');
    const { control, formState, handleSubmit } = useForm({
        mode: 'all',
        defaultValues: {
            title: relationship.title
        }
    });
    const { logBI } = useStoreActions();
    const updateRelationship = useUpdateRelationship();
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        title: texts.title(),
        onCloseButtonClick: dismissModal,
        primaryButtonTestId: "rename-agr",
        primaryButtonDisabled: !formState.isDirty,
        primaryButtonLabel: texts.save(),
        secondaryButtonLabel: texts.cancel(),
        onPrimaryButtonClick: handleSubmit(async (param)=>{
            let { title } = param;
            updateRelationship(_object_spread_props(_object_spread({}, relationship), {
                changes: [
                    agreementChangeModel.makeTitleChange(title)
                ],
                onSuccess: ()=>{
                    logBI(14050);
                    onSuccess(title);
                    dismissModal();
                }
            }));
        }),
        onSecondaryButtonClick: dismissModal,
        content: /*#__PURE__*/ _jsx("div", {
            className: styles.content,
            children: /*#__PURE__*/ _jsx(Controller, {
                control: control,
                name: "title",
                rules: agreementNameValidation,
                render: (p)=>/*#__PURE__*/ _jsx(TextField, _object_spread({
                        collapseHelperText: false,
                        autoFocus: true,
                        testId: "agr-name",
                        label: texts.agreementNameLabel()
                    }, connectControllerToTextField(p)))
            })
        })
    });
}
